import { DocManagementConfiguration, DocManagementServiceProvider } from '@centecomm/portal-service-react';
import DocManagementUploadContext from 'Shared/DocumentManagement/Upload/DocManagementUploadContext';
import React, { ReactNode, useMemo } from 'react';

type DocMgmtProviderConfigProps = {
    children: ReactNode;
    token: string;
};

const CoreProviderConfig: React.FC<DocMgmtProviderConfigProps> = ({ children, token }: DocMgmtProviderConfigProps) => {
    const serviceConfig = useMemo<DocManagementConfiguration>(
        () => ({
            apiRoot: DOC_MGMT_API_ROOT || '',
            options: {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            },
        }),
        [token],
    );

    const [showUploadModal, setShowUploadModal] = React.useState<boolean>(false);
    const docManagementContextValue = useMemo(() => ({ showUploadModal, setShowUploadModal }), [showUploadModal]);

    return (
        <DocManagementServiceProvider configuration={serviceConfig}>
            <DocManagementUploadContext.Provider value={docManagementContextValue}>
                {children}
            </DocManagementUploadContext.Provider>
        </DocManagementServiceProvider>
    );
};

export default CoreProviderConfig;
